import { Iso8601DateTimeString } from '../../../../../types/Iso8601DateTimeString';
import { ScheduleMessage } from '../../../../../types/ScheduleMessage';
import { Text } from '../../../../cdl/Text/Text';
import { formatDateTime } from '../../../../common/helpers/formatDateTime.helper';
import { Characters } from '../../../../common/helpers/unicode.helper';
import { Box } from '../../../../common/ui/Box';

interface ScheduleStopTimeProps {
    title: string;
    stop: ScheduleMessage;
    date: Iso8601DateTimeString;
}

export const ScheduleStopTime = ({ title, stop, date }: ScheduleStopTimeProps) => {
    const timeZoneId = stop.port?.timeZoneId ?? 'UTC';
    const isUtc = !stop.port?.timeZoneId;

    const formattedDate = formatDateTime({
        date: date,
        timeZoneId: timeZoneId,
        format: 'MMM d, yyyy',
    });

    const formattedTime = formatDateTime({
        date: date,
        timeZoneId: timeZoneId,
        format: 'h:mm a',
    });

    const gridTemplateColumns = isUtc ? '2fr 3fr 3fr' : '3fr 3fr 2fr';

    return (
        <Box display="grid" gridTemplateColumns={gridTemplateColumns} columnGap={8}>
            <Text variant="extraSmall" color="foreground.subtle">
                {title}
            </Text>

            <Text variant="extraSmall" style={{ textAlign: 'right' }}>
                {formattedDate}
            </Text>

            <Text variant="extraSmall" style={{ textAlign: 'right' }}>
                {formattedTime}
                {isUtc ? <>{Characters.NO_BREAK_SPACE}UTC</> : null}
            </Text>
        </Box>
    );
};
